<script setup>
import {watch} from "vue";
import {ElNotification} from "element-plus";
import {useStore} from "@/state/store";
const store = useStore()


watch(
  () => store.messages.slice(), // следим за копией, чтобы отловить push
  (newMessages, oldMessages) => {
    if (newMessages.length > oldMessages.length) {
      const last = newMessages[newMessages.length - 1]
      if (last) {
        let message = typeof last === 'object' ? last.message : last
        let type_ = typeof last === 'object' ? last.type : 'error'

        ElNotification({
          title: 'Уведомление',
          message: message,
          type: type_, // можно: success, warning, error, info
          duration: 3000,
          position: 'bottom-right',
        })
      }
    }
  },
  { deep: true }
)
</script>

<template></template>